import { render, staticRenderFns } from "./AllDashboard.vue?vue&type=template&id=15384324&"
import script from "./AllDashboard.vue?vue&type=script&lang=js&"
export * from "./AllDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports